module.exports = __webpack_public_path__ + "static/img/a028.2c3779d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a028.jpg
// module id = HMRx
// module chunks = 0